import { Alert as MuiAlert } from '@mui/material';

export const Alert = (props:any) => {

  return <MuiAlert {...props}/>
};
